// extracted by mini-css-extract-plugin
module.exports = {"poweredCon":"style_poweredCon__HmYFU","text":"style_text__30_FS","poweredImg":"style_poweredImg__Xr4K6"};